import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";
import { EXAM_TYPES } from "./epocus-exam-worksheets";

export const RXDB_EPOCUS_PROGRAM_COLLECTION_NAME = "epocus-program";

export const useRxCollectionEpocusProgram =
  (): RxCollection<EpocusProgram> | null =>
    useRxCollection<EpocusProgram>(RXDB_EPOCUS_PROGRAM_COLLECTION_NAME);

type UseRxData = Parameters<typeof useRxData<EpocusProgram>>;
export type EpocusProgramQueryConstructor = UseRxData["1"];

export type EpocusProgramStatus = "active" | "disabled";

const EPOCUS_PROGRAM_SCHEMA_LITERAL = {
  title: "epocus program schema",
  version: 3,
  description: "An ePOCUS program the signed-in user is a member of",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    name: {
      type: "string",
      maxLength: 200,
    },
    status: {
      type: "string",
      maxLength: 20,
      enum: ["active", "disabled"],
    },
    elephantFacilityId: {
      type: ["string", "null"],
    },
    dimseAeTitle: {
      type: ["string", "null"],
      maxLength: 16,
    },
    enabledExamTypes: {
      type: "array",
      items: {
        type: "string",
        enum: EXAM_TYPES,
      },
    },
    enabledDeviceIds: {
      type: "array",
      items: {
        type: "string",
      },
    },
    meta: SYNCABLE_META,
  },
  required: [
    "id",
    "name",
    "status",
    "enabledExamTypes",
    "enabledDeviceIds",
    "meta",
  ],
  indexes: [["name"]],

  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(EPOCUS_PROGRAM_SCHEMA_LITERAL);

export type EpocusProgram = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const EPOCUS_PROGRAM_SCHEMA: RxJsonSchema<EpocusProgram> =
  EPOCUS_PROGRAM_SCHEMA_LITERAL;
